import customAxios from './middleware';

export const postUser = async (payload) => customAxios.post('/users', payload, { headers: { isClientCredentials: true } })
export const checkUser = async (identifier, type) => customAxios.get(`/users?${type}=${identifier}`, { headers: { isClientCredentials: true } })
export const sendConfirmationCodeToUser = async (type, value) => customAxios.post(`/users/totp-send?${type}=${value}`, {}, { headers: { isClientCredentials: true } })
